import React from 'react';
interface AIOutlineButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}
export const AIOutlineButton: React.FC<AIOutlineButtonProps> = ({
  children,
  className = '',
  ...props
}) => {
  return <button className={`gb-gradient-outline inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-normal text-black transition-colors ${className}`} {...props} data-id="element-1614">
      {children}
    </button>;
};